import Phaser from 'phaser';
import { PowerUp, PowerUpConfig, WeightClass } from './PowerUp';

export interface AmmoPowerUpConfig extends PowerUpConfig {
  /** Weapon ID this ammo is for (e.g., 'doublelaser', 'plasmabomb') */
  weaponId: string;
  /** Amount of ammo to give - used by data system */
  ammoAmount: number;
  /** Display name of the weapon (for notification) */
  weaponName?: string;
}

/**
 * AmmoPowerUp - Gives player ammo for a specific weapon
 *
 * From C3: upDoubleLaser, upPlasmaBomb, upMissile, upRaySonic, upMineExplosive
 * Effects are handled by data-driven system (powerups-overrides.json)
 *
 * Use DataManagerPowerUp.getAmmoConfig(weaponId) to get config for creating instances.
 */
export class AmmoPowerUp extends PowerUp {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    config: AmmoPowerUpConfig
  ) {
    super(scene, x, y, texture, {
      ...config,
      weight: config.weight ?? WeightClass.Light,
      bioMatter: config.bioMatter ?? 0,
    });
  }
}
